var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-badge',{attrs:{"bordered":"","color":"error","icon":"mdi-lock","overlap":""}},[_c('ix-button-action',{staticClass:"text-[12px]",attrs:{"icon":"mdi-refresh","loading":_setup.loading},on:{"click":_setup.handleRecalculate}},[_vm._v("\n    "+_vm._s(_vm.$t('recalculate'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }